import gql from "graphql-tag";

// fragment
export const CUSTOMER_FRAGMENT = gql`
    fragment customer on CustomerNode {
        id
        name
        address1
        address2
        zipCode
        city
        country
        updatedAt
        updatedBy
    }
`;

// all query
export const CUSTOMERS_QUERY = gql`
    query {
        customers {
            edges {
                cursor
                node {
                    ...customer
                }
            }
        }
    }
    ${CUSTOMER_FRAGMENT}
`;

// single query
export const SINGLE_CUSTOMER_QUERY = gql`
    query customer($id: ID!) {
        customer(id: $id) {
            ...customer
        }
    }
    ${CUSTOMER_FRAGMENT}
`;

// create
export const CREATE_CUSTOMER_MUTATION = gql`
    mutation createCustomer($input: CreateCustomerInput!) {
        createCustomer(input: $input) {
            customer {
                ...customer
            }
        }
    }
    ${CUSTOMER_FRAGMENT}
`;

// update
export const UPDATE_CUSTOMER_MUTATION = gql`
    mutation updateCustomer($input: UpdateCustomerInput!) {
        updateCustomer(input: $input) {
            customer {
                ...customer
            }
        }
    }
    ${CUSTOMER_FRAGMENT}
`;

// delete
export const DELETE_CUSTOMER_MUTATION = gql`
    mutation deleteCustomer($input: DeleteCustomerInput!) {
        deleteCustomer(input: $input) {
            customer {
                ...customer
            }
        }
    }
    ${CUSTOMER_FRAGMENT}
`;
